const inicialState = {
  dataInicio: '',
  dataFim: '',
  filtroValue: '',
  lista: [],
  tipo: '',
  imprimir: false,
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Relatorios/store/relatorios.state.js